module.exports = __webpack_public_path__ + "static/img/99042D_3_R_20200416_LC.52c47d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/99042D_3_R_20200416_LC.png
// module id = t1l1
// module chunks = 0